<template>
  <v-container>
    <v-row>
      <v-col>
        <OfferDocumentationForm
            ref="offerDocument"
            hide-button
            @closeDialog="() => {$emit('dialogClosed')}"
        />
      </v-col>
    </v-row>
  </v-container>
</template>
<script>

import OfferDocumentationForm from '@/modules/book/views/task/components/OfferDocumentationForm.vue';

export default {
  name: 'CreateOfferStep',
  components: {OfferDocumentationForm},
  data() {
    return {
      inputData: {}
    }
  },
  methods: {
    setInputData(inputData) {
      this.inputData = inputData;
      this.$refs.offerDocument.setInputData(inputData);
    },
    save() {
      this.$refs.offerDocument.save();
    },
    cancelDialog() {
      this.$refs.offerDocument.clearForm();
      this.inputData = {}
    }
  }
}
</script>